module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAlBAMAAADYclYOAAAAGFBMVEV7mcR7mcR7mcR7mcR7mcR7mcR7mcR7mcTE+EQ9AAAACHRSTlP5AjvSGbVnlG6OGW0AAADxSURBVCjPVdCxbsJADMbxT0Qps6MUVk4MXTOUB4jyAq1UqSsM7GHh+bE/27njBoT++smXM+RrlvY8BQN+23LEDSf0bVqxwwo8ajkAPSZgX9MVelTVaUeYOtlvnQR86I2VGdIbpWFEM6QyRwKpjEgsJQtkydmciIlsb4UPsUTGY0jTfXYWk/4FB3xvTNEnl9NtTNGPPkin/gUjQmfLSUakye72aY50OQucTYF00fqfbCiOUCDB9IxE+qljsET2oMVfnchSskB89tmmlSEQE1k3BfLlLLmJnWQiS+QpGVGkYKVJzhxlIitvyVigLY3rJZC8AGlzLsFN1EfyAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon2.png
// module id = PM2Y
// module chunks = 1